import React from 'react'
import { ICartOrder, IOrderPrice } from 'order_components/IOrder'
import './StylesCartPage.css'

const getProductCount = (order: ICartOrder) => {
  let count = 0
  order.products.forEach((prod) => {
    count += prod.quantity
  })
  return count
}

const getProperEnding = (order: ICartOrder) => {
  const count = getProductCount(order)
  let val = count % 100

  if (val > 10 && val < 20) {
    return count + ' товаров'
  } else {
    val = count % 10
    if (val === 1) {
      return count + ' товар'
    } else if (val > 1 && val < 5) {
      return count + ' товара'
    } else {
      return count + ' товаров'
    }
  }
}

interface IOrderPricePanelProps {
  cart: ICartOrder
  orderPrice: IOrderPrice
  showProducts: boolean
}

const OrderPricePanel: React.FC<IOrderPricePanelProps> = ({
  cart,
  orderPrice,
  showProducts,
}) => {
  return (
    <div className='price-panel py-dynamic-mini'>
      {/* <h6>Товары и услуги: {orderPrice.total_price - orderPrice.delivery_price} ₽</h6> */}
      {/* <h6>Доставка: {orderPrice.delivery_price} ₽</h6> */}
      <h6>{getProperEnding(cart)}</h6>
      {showProducts && (
        <div className='hide-if-small'>
          <ul>
            {cart.products.map((product) => (
              <li key={product.product_id}>
                {product.quantity > 1 && <>{product.quantity} x </>}
                {product.name}
              </li>
            ))}
          </ul>
        </div>
      )}
      <h5>На сумму {orderPrice.total_price} ₽</h5>
      {orderPrice.total_price >= 50000 && (
        <h6>Слишком дорогой заказ для оплаты по карте</h6>
      )}
    </div>
  )
}
export default OrderPricePanel
